import "core-js/stable";
import "regenerator-runtime/runtime";

import "./stylesheets/app.scss";

import events from "./events";
import {initEvents, VueModal} from "@busy-human/vue-component-library";
initEvents(events);


import app from "./app";

import { initRaygun, setTags } from "@busy-human/raygun-util";
initRaygun(CONFIG.raygun.apiKey, { Vue: app, version: VERSION, environment: ENVIRONMENT});
setTags([`environment:${ENVIRONMENT}`]);


import { createPinia } from 'pinia';
const pinia = createPinia();
app.use(pinia);

import { useAuth } from '@/store/auth';
useAuth();

import Toast, { POSITION, PluginOptions } from 'vue-toastification';
import "vue-toastification/dist/index.css";

const ToastOptions: PluginOptions = {
    position: POSITION.BOTTOM_RIGHT,
};
app.use(Toast, ToastOptions);

import router from "./router";
app.use(router);

app.component("v-modal", VueModal);
app.mount("#application-root");
